/* eslint-disable */
import API from '@/api';

const AUTH_REQUEST = 'AUTH_REQUEST';
const AUTH_SUCCESS = 'AUTH_SUCCESS';
const AUTH_ERROR = 'AUTH_ERROR';
const AUTH_LOGOUT = 'AUTH_LOGOUT';

const authModule = {
  state: {
    auth: {
      token: localStorage.getItem('user-token') || '',
      status: '',
    },
  },
  getters: {
    isAuthenticated: state => !!state.auth.token,
    authStatus: state => state.auth.status,
    authToken: state => state.auth.token,
  },
  mutations: {
    [AUTH_REQUEST]: state => {
      state.auth.status = 'loading';
    },
    [AUTH_SUCCESS]: (state, token) => {
      state.auth.status = 'success';
      state.auth.token = token;
    },
    [AUTH_ERROR]: state => {
      state.auth.status = 'error';
    },
    [AUTH_LOGOUT]: state => {
      state.auth.status = '';
      state.auth.token = '';
    },
  },
  actions: {
    requestAuth: ({ commit, dispatch }, user) =>
      new Promise((resolve, reject) => {
        commit(AUTH_REQUEST);
        API.loginUser(user)
          .then(resp => {
            const token = resp.data.token;
            localStorage.setItem('user-token', token);
            commit(AUTH_SUCCESS, token);
            dispatch('USER_REQUEST');
            resolve(resp);
          })
          .catch(err => {
            commit(AUTH_ERROR, err);
            localStorage.removeItem('user-token');
            reject(err);
          });
      }),
    logout: ({ commit, dispatch }) =>
      new Promise((resolve, reject) => {
        localStorage.removeItem('user-token');
        commit(AUTH_LOGOUT);
        resolve();
      }),
  },
};

export default authModule;
